import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import Config from "../config/"
import ContentWrapper from "../styles/ContentWrapper"
import Logo from "./logo"

const { footerLinks } = Config

const StyledFooter = styled.footer`
  width: 100%;
  height: ${({ theme }) => theme.footerHeight};
  background: ${({ theme }) => theme.colors.primary};
  margin-top: 10rem;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .footer {
      text-align: center;
      color: ${({ theme }) => theme.colors.tertiaryText};
      a {
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .footer-links {
      /* Adjust width of links wrapper accordingly */
      width: 10rem;
      display: flex;

      justify-content: space-between;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 15rem;
      }
    }
  }
`

const StyledLink = styled(Link)`
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #ffffff;
  letter-spacing: 1px;
`

const Footer = () => (
  <StyledFooter>
    <StyledContentWrapper>
      <div className="footer">
        &copy; All rights reserved | Designed & Developed by:{" "}
        <a href="https://twitter.com/shubhski" target="_new">
          Shubham Singh
        </a>
      </div>
    </StyledContentWrapper>
  </StyledFooter>
)

export default Footer
